(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = global || self, factory(global.pecrUtil = {}));
}(this, (function (exports) { 'use strict';

    var getCookieValue = function (cookieName, cookies) {
        if (typeof cookies === 'object') {
            return cookies[cookieName];
        }

        if (typeof document === 'object') {
            var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
            if (match) return match[2];
        }
    };

    var cookiePrefix = 'JOHNLEWIS_ENSIGHTEN_PRIVACY_';

    var storageCanBeSet = function (cookieGroup, cookies) {
        if (typeof cookieGroup === 'undefined') {
            throw new Error('pecr-util: Expected a cookie group to be supplied, e.g. "Functional"');
        }

        if (typeof document === 'undefined' && typeof cookies === 'undefined') {
            throw new Error('pecr-util: When running on the server you need to supply an object of cookies from the request');
        }

        return getCookieValue(cookiePrefix + cookieGroup, cookies) === '1';
    };

    exports.cookiePrefix = cookiePrefix;
    exports.storageCanBeSet = storageCanBeSet;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
